import { getUrls } from '@zapier/product-dev-platform/src/utils/urls';

export const getNavLinks = (isAuthed: boolean, host: string) => {
  const urls = getUrls(host);

  const dynamicLinks = isAuthed
    ? [
        {
          label: 'My integrations',
          href: urls.vbBase,
          visibility: 'users' as const,
        },
      ]
    : [
        {
          label: 'Build integration',
          href: urls.buildIntegration,
          visibility: 'visitors' as const,
        },
      ];

  const fixedLinks = [
    {
      label: 'Docs',
      href: urls.docs,
      visibility: 'everyone' as const,
    },
    {
      label: 'Tools',
      href: urls.tools,
      visibility: 'everyone' as const,
    },
    {
      label: 'Partner Program',
      href: urls.partnerProgram,
      visibility: 'everyone' as const,
    },
    {
      label: 'Resources',
      href: urls.resources,
      visibility: 'everyone' as const,
    },
  ];

  return [...dynamicLinks, ...fixedLinks];
};
